import { render, staticRenderFns } from "./StallionStocksListe.vue?vue&type=template&id=40784497&"
import script from "./StallionStocksListe.vue?vue&type=script&lang=js&"
export * from "./StallionStocksListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports